// src/styles/theme.js
export const darkTheme = {
  background: "#181818",
  card: "#1f1f1f",
  text: "#f5f5f5",
  subtext: "#b0b0b0",
  accent: "#10b981",
  hover: "#10b9812a",
  border: "#2e2e2e",
};

export const lightTheme = {
  background: "#fafafa",
  card: "#ffffff",
  text: "#1a1a1a",
  subtext: "#4b4b4b",
  accent: "#7cb342", // slightly warmer olive green
  hover: "#7cb342",
  border: "#e0e0e0",
};
